//react
import injectSheet from "react-jss";

// styles
import styles from "./stackitem_styles";

//icons
import { ReactComponent as Close } from "assets/icons/dismiss.svg";

const stackItem = injectSheet(styles)((props) => {

    const {handleDeletion , item} = props;

    const handleRemoval = () => {
        handleDeletion(item)
    }

    return (
        <div className={`stackitem ${props.classes.stackItem}`}>
            <div className={`stackitemlabel ${props.classes.label}`}>
                {item.value}
            </div>
            <div className={`removeitem ${props.classes.removeItem}`}>
                <button className={`removeitembutton`} onClick={handleRemoval}>
                                    <span className={`close`}>
                                       <Close></Close>
                                    </span>
                </button>
            </div>
        </div>
    )
})

export default stackItem;